import * as d3 from 'd3';

export function drawPrairieGrillsOculus(
  svg,
  x,
  y,
  width,
  height,
  frameWidth = 10,
  offset = 0.15,
  lineColor = 'white',
  borderColor = 'black',
  borderWidth = 0.2,
  grillThickness = 2,
  radiusX = width / 2,
  radiusY = height / 2,
  outerShape = 'Rect'
) {
  const glassX = x;
  const glassY = y;
  const glassWidth = width;
  const glassHeight = height;

  const offsetX = glassWidth * offset;
  const offsetY = glassHeight * offset;

  // ALWAYS clip grills to the inner glass ellipse (oculus is always a circle/oval)
  const clipId = `ellipseClip_${Math.random().toString(36).substring(2, 11)}`;
  const centerX = glassX + glassWidth / 2;
  const centerY = glassY + glassHeight / 2;

  svg.append('defs')
    .append('clipPath')
    .attr('id', clipId)
    .append('ellipse')
    .attr('cx', centerX)
    .attr('cy', centerY)
    .attr('rx', radiusX)
    .attr('ry', radiusY);

  const grillContainer = svg.append('g')
    .attr('clip-path', `url(#${clipId})`);

  // Vertical side grills (left and right)
  [offsetX, glassWidth - offsetX].forEach((gx) => {
    grillContainer.append('rect')
      .attr('x', glassX + gx - grillThickness / 2)
      .attr('y', glassY)
      .attr('width', grillThickness)
      .attr('height', glassHeight)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);
  });

  // Horizontal top/bottom grills
  [offsetY, glassHeight - offsetY].forEach((gy) => {
    grillContainer.append('rect')
      .attr('x', glassX)
      .attr('y', glassY + gy - grillThickness / 2)
      .attr('width', glassWidth)
      .attr('height', grillThickness)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);
  });
}


